<script lang="ts" setup>
import { qaConfig } from '@shared/config'

import { useLessonRoomStore } from '../model/store'
import { useClassroomChat } from '../model/chat.hook'
import LessonRoomControlButton from './lesson-room/LessonRoomControlButton.vue'

defineOptions({
  name: 'ButtonChat',
})

const lessonRoomStore = useLessonRoomStore()
const { toggleChat, isReady } = useClassroomChat()
</script>

<template>
  <LessonRoomControlButton
    :icon="{ name: 'message' }"
    label="Chat"
    :enabled="lessonRoomStore.isChatOpen"
    :has-alert="lessonRoomStore.hasChatUnread"
    :disabled="!isReady"
    :data-qa="qaConfig.attributes.buttonChat"
    @click="toggleChat"
  />
</template>
